import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import HashIcon from "assets/icons/down.svg?react";
import { useEffect, useRef, useState } from "react";
import {
  faCaretDown,
  faCaretRight,
} from "@fortawesome/free-solid-svg-icons";
import { useOnClickOutside } from "usehooks-ts";
import { getDossierItemCategoryLabel } from "utils/getDossierItemCategoryLabel";
import { useTranslation } from "react-i18next";

const SidebarDossierFilterChooseCategory: FC<Props> = ({
  onChoose,
  label,
  initOpen = false,
  onClose,
  className = "",
  types: typed,
}) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (active) {
      setActive(false);
    }

    if (onClose && !label) {
      onClose();
    }
  });

  useEffect(() => {
    if (!initOpen) return;
    setActive(true);
  }, [initOpen]);

  return (
    <div ref={outsideRef} className={`${styles.wrapper}`}>
      <div
        onClick={() => setActive(!active)}
        className={`${styles.card} ${className}`}
      >
        <div className={styles.left}>
          <HashIcon className={styles.icon} /> {label ? label : t("common.type")}{" "}
        </div>

        <div className={styles.right}>
          {!onClose && (
            <FontAwesomeIcon icon={active ? faCaretDown : faCaretRight} />
          )}
        </div>
      </div>

      {active && (
        <div className={styles.dropdown}>
          <div className={styles.list}>
            {typed.map((type) => (
              <div
                onClick={() => {
                  onChoose(type);
                  setActive(false);
                }}
                className={styles.box}
                key={type.valueOf()}
              >
                {/* {<type.image />} */}
                {getDossierItemCategoryLabel(type)}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarDossierFilterChooseCategory;
